import { render } from "./GrupoLista.vue?vue&type=template&id=01ab4e12"
import script from "./GrupoLista.vue?vue&type=script&lang=js"
export * from "./GrupoLista.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__